import type { MutableRefObject } from 'react';
import { useDraftLoader } from './useDraftLoader';
import { useTelemetry } from './useTelemetry';
import { useDraftAutoSave } from './useDraftAutoSave';

export function useDataCenterDrafts(
  code: string,
  currentDraftId: number | null,
  setCurrentDraftId: (id: number | null) => void,
  dc: any,
  currentDraftRevision: number | null,
  hadDraftId: MutableRefObject<boolean>,
) {
  // 1. Loader hook for API sync
  useDraftLoader(code, currentDraftId, dc);

  // 2. Telemetry polling hook
  useTelemetry(code);

  // 3. AutoSave and Publish hook
  return useDraftAutoSave(code, currentDraftId, setCurrentDraftId, dc, hadDraftId, currentDraftRevision);
}
